import React from 'react';
import { useSelector } from 'react-redux';
import { Breadcrumb } from 'antd';
import { useAtomValue } from 'jotai';
import { Divider, HeaderWrapper, LeftSideHeader, RightSideHeader, Title } from './styled';
import { useResetPanelAtoms } from './hooks';
import {
  createIntegrationAtom,
  editIntegrationAtom,
  isEditCreateFormOpenAtom,
  partnerAtom,
} from './atoms';
import { CloseOutlined } from '@ant-design/icons';
import { isAdminRoleSelector } from '@src/store/common/selectors';
import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';
import { DataSourceMapping } from '@src/pages/SavedDashboards/utils';
import AdminOnly from '@src/components/common/AdminOnly';

export const Header = ({ closeDrawer }) => {
  const editIntegration = useAtomValue(editIntegrationAtom);
  const createIntegration = useAtomValue(createIntegrationAtom);
  const isEditCreateFormOpen = useAtomValue(isEditCreateFormOpenAtom);
  const partner = useAtomValue(partnerAtom);
  const resetAtoms = useResetPanelAtoms();
  const isAdminUser = useSelector(isAdminRoleSelector);
  const breadcrumbItems = [
    {
      key: 'More Channels',
      title: (
        <>
          More Channels
          <AdminOnly style={{ position: 'relative', top: '-3px', marginLeft: '10px' }} />
        </>
      ),
      clickable: isEditCreateFormOpen,
      show: true,
      onClick: isEditCreateFormOpen
        ? () => {
            resetAtoms.reset();
          }
        : undefined,
    },
    {
      key: 'New Integration',
      title: `New ${partner?.name} Integration`,
      clickable: false,
      show: createIntegration,
    },
    {
      key: 'Edit Integration',
      title: isAdminUser
        ? `Edit ${partner?.name} Integration`
        : `View ${partner?.name} Integration`,
      clickable: false,
      show: !!editIntegration.configId,
    },
  ];

  return (
    <HeaderWrapper>
      <LeftSideHeader>
        <Title>{DataSourceMapping[CURRENT_PRODUCT_MODE.toLowerCase()]}</Title>
        <Divider />

        <Breadcrumb separator=">">
          {breadcrumbItems.map((item) =>
            item.show ? (
              <Breadcrumb.Item onClick={item.onClick} key={item.key}>
                <Title clickable={item.clickable}>{item.title}</Title>
              </Breadcrumb.Item>
            ) : null,
          )}
        </Breadcrumb>
      </LeftSideHeader>

      <RightSideHeader>
        <CloseOutlined style={{ paddingTop: '8px' }} onClick={closeDrawer} />
      </RightSideHeader>
    </HeaderWrapper>
  );
};
